import React, { Component, PropTypes } from 'react';
import debounce from 'lodash.debounce';

class EmailLink extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: 'We are processing your request ...',
    };
  }

  componentWillMount() {
    const { routeName, params, history } = this.props;
    const { token } = params;
    if (routeName === 'confirmation') {
      return this.props.confirmSigninEmail(token);
    }
    const fn = this.getProcessEmailLinkFunc();
    fn(token)
    .then((res) => {
      if (routeName === 'secondary-confirmation') {
        if (res.payload.error) {
          history.push('/signin/resend-confirmation');
        } else {
          this.setState({ content: res.payload.message });
          this.debounceTransition();
        }
      } else if (routeName === 'confirmation') {
        const error = res ? res.payload.error : undefined;
        if (error) history.push('/signin/resend-confirmation');
        else history.push('/signin');
      } else if (routeName === 'confirm-disassociate') {
        if (res.payload.error) {
          history.push('/signin/disassociate-secondary');
        } else {
          this.setState({ content: res.payload.message });
          debounce(() => {
            history.push('/signin');
          })();
        }
      }
    })
    .catch((err) => {
      console.log('err in email-link', err);
    });
  }

  getProcessEmailLinkFunc() {
    switch (this.props.routeName) {
      case 'secondary-confirmation':
        return this.props.confirmSecondaryEmail;
      case 'confirm-disassociate':
        return this.props.confirmDisassociateSecondary;
      default:
        return this.props.confirmSecondaryEmail;
    }
  }

  debounceTransition = debounce(() => {
    window.location = `${window.location.protocol}//${window.location.host}/settings`;
  }, 4000);

  render() {
    return (
      <div className="l-app-content" style={{ textAlign: 'center' }}>
        <h2>{this.state.content}</h2>
      </div>
    );
  }
}

EmailLink.propTypes = {
  routeName: PropTypes.string,
  history: PropTypes.object,
  params: PropTypes.object,
  confirmSigninEmail: PropTypes.func,
  confirmSecondaryEmail: PropTypes.func,
  confirmDisassociateSecondary: PropTypes.func,
};

export default EmailLink;



// WEBPACK FOOTER //
// ./src/app/components/signin/email-link.jsx